<script lang="ts">
  import { onDestroy } from 'svelte';

  import type { TeoCore } from '@/teoCore/TeoCore';
  import type { TeoText } from '@/teoCore/text/TeoText';

  import EditorWrapper from './EditorWrapper.svelte';

  let { teoCore }: { teoCore: TeoCore } = $props();
  let text = $state(teoCore.activeText);

  teoCore.events.addEventListener('activeTextChanged', onTextChange);

  onDestroy(() => {
    teoCore.events.removeEventListener('activeTextChanged', onTextChange);
  });

  function onTextChange(e: TeoText) {
    text = e;
  }
</script>

{#key text.id}
  <EditorWrapper {text} />
{/key}
